module.exports = __webpack_public_path__ + "img/pluspay.25fdf8ae.png";